export const apiPath = '/v1/destruction_events';
const actionType = 'DESTRUCTION_EVENT';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
